function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

const priceFormat = function (price, currencyCode, _country, _language) {
  let _currencyDisplay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "symbol";
  let formattedPrice = "";
  let country = _country.toUpperCase();
  let language = _language.toLowerCase();
  let currencyDisplay = _currencyDisplay;
  if (price !== null && price !== "") {
    if (language === "jp") {
      language = "ja"; // fix bad country config in TAS
    }

    // Match us/en formatting for us/es SWAT-5418
    // Note by Jamie Chong - July 23, 2020. This SWAT ticket was generated based off Proposed Price Formats document
    // which shows 5 digit prices for the example. for the es-US locale, the Intl number formatter uses a comma for 5 digit
    // prices, but NOT for 4 digit prices. Assuming the Intl lib is correct and standard, I suggest we remove this "fix".
    if (country === "US" && language === "es") {
      language = "en";
    }

    // special case to get correct format for JPY SHOP-311 - eg: ¥12,346 (税込)
    // we want locale to be ja-CA to get the format we want
    if (currencyCode === "JPY") {
      language = "ja";
      country = "CA";
    }

    // When country/currency is NOK always display with CODE (not symbol like `kr`)
    if (country === "NO") {
      currencyDisplay = "code";
    }

    // When language is no, be consitent with showing CA$ and US$
    // (if using no as language, the currency code is not consistent between runtimes)
    if (language === "no" && (country === "CA" || country === "US")) {
      language = "zh";
    }
    const locale = `${language}-${country}`; // ex: en-CA, ja-JP, fr-CA

    formattedPrice = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
      currencyDisplay
    }).format(price);

    // formattedPrice = Number(price).toLocaleString(locale, { style: "currency", currency: currencyCode, currencyDisplay });

    if (currencyCode === "JPY" && currencyDisplay === "symbol") {
      formattedPrice += " (税込)";
    }
  }
  return formattedPrice;
};

/**
 * /* Returns the price display settings from a country code that is provided.
 *
 * @param {country_code}  ISO 3166-2-alpha 2 country code
 * @returns the currency data for price display
 *
 */

const unknownCountry = {
  currencySymbolRight: false,
  currencySymbol: "",
  currency: "",
  code: ""
};
function priceDisplaySettings(countryCode) {
  const euroSettings = {
      currencySymbolRight: true,
      currency: "",
      currencySymbol: "€",
      code: "EUR"
    },
    countries = {
      CA: {
        currencySymbolRight: false,
        currencySymbol: "$",
        currency: "CAD",
        code: "CAD"
      },
      GB: {
        currencySymbolRight: false,
        currency: "",
        currencySymbol: "£",
        code: "GBP"
      },
      US: {
        currencySymbolRight: false,
        currency: "USD",
        currencySymbol: "$",
        code: "USD"
      },
      AT: euroSettings,
      BE: euroSettings,
      CZ: euroSettings,
      DE: euroSettings,
      ES: euroSettings,
      FI: euroSettings,
      FR: euroSettings,
      IE: euroSettings,
      IT: euroSettings,
      NL: euroSettings,
      DK: {
        currencySymbolRight: false,
        currency: "DKK",
        currencySymbol: "kr",
        code: "DKK"
      },
      SE: {
        currencySymbolRight: false,
        currency: "SEK",
        currencySymbol: "kr",
        code: "SEK"
      },
      NO: {
        currencySymbolRight: true,
        currency: "",
        currencySymbol: "NOK",
        code: "NOK"
      },
      CH: {
        currencySymbolRight: false,
        currency: "",
        currencySymbol: "CHF",
        code: "CHF"
      },
      PL: {
        currencySymbolRight: true,
        currency: "",
        currencySymbol: "zł",
        code: "PLN"
      },
      JP: {
        currencySymbolRight: false,
        currency: "¥",
        currencySymbol: "¥",
        code: "JPY"
      },
      CN: {
        currencySymbolRight: false,
        currency: "",
        currencySymbol: "¥",
        code: "CNY"
      }
    };
  return Object.assign({}, countries[countryCode] || unknownCountry);
}
function buildPriceModel(value, country, language) {
  const priceDisplay = priceDisplaySettings(country.toUpperCase());
  const formattedNumber = priceFormat(value, priceDisplay.code, country, language, "code").replace(/[A-Z]/g, "").trim();
  const displayPrice = priceFormat(value, priceDisplay.code, country, language);
  priceDisplay.formattedNumber = formattedNumber;
  return _objectSpread2({
    formattedNumber,
    displayPrice
  }, priceDisplay);
}

function getCurrencyCode(countryCode, currencyOnly) {
  switch (countryCode.toUpperCase()) {
    case "US":
      if (currencyOnly) {
        return "USD";
      }
      return "US_USD";
    case "CA":
      if (currencyOnly) {
        return "CAD";
      }
      return "CA_CAD";
    case "DE":
      if (currencyOnly) {
        return "EUR";
      }
      return "DE_EUR";
    case "GB":
      if (currencyOnly) {
        return "GBP";
      }
      return "GB_GBP";
    case "PL":
      if (currencyOnly) {
        return "PLN";
      }
      return "PL_PLN";
    case "DK":
      if (currencyOnly) {
        return "DKK";
      }
      return "DK_DKK";
    case "NO":
      if (currencyOnly) {
        return "NOK";
      }
      return "NO_NOK";
    case "SE":
      if (currencyOnly) {
        return "SEK";
      }
      return "SE_SEK";
    case "AT":
      if (currencyOnly) {
        return "EUR";
      }
      return "AT_EUR";
    case "BE":
      if (currencyOnly) {
        return "EUR";
      }
      return "BE_EUR";
    case "CH":
      if (currencyOnly) {
        return "CHF";
      }
      return "CH_CHF";
    case "CZ":
      if (currencyOnly) {
        return "EUR";
      }
      return "CZ_EUR";
    case "ES":
      if (currencyOnly) {
        return "EUR";
      }
      return "ES_EUR";
    case "FI":
      if (currencyOnly) {
        return "EUR";
      }
      return "FI_EUR";
    case "FR":
      if (currencyOnly) {
        return "EUR";
      }
      return "FR_EUR";
    case "IE":
      if (currencyOnly) {
        return "EUR";
      }
      return "IE_EUR";
    case "IT":
      if (currencyOnly) {
        return "EUR";
      }
      return "IT_EUR";
    case "JP":
      if (currencyOnly) {
        return "JPY";
      }
      return "JP_JPY";
    case "CN":
      if (currencyOnly) {
        return "CNY";
      }
      return "CN_CNY";
    case "NL":
      if (currencyOnly) {
        return "EUR";
      }
      return "NL_EUR";
    default:
      if (currencyOnly) {
        return "CAD";
      }
      return "CA-CAD";
  }
}

const fetchPriceList = async function (country) {
  let url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "//price-api.arcteryx.com";
  let sessionStorage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.sessionStorage;
  country = country.toUpperCase(); //eslint-disable-line
  let list = await fetch(`${url}/${country}.json`);
  list = await list.json();
  sessionStorage.setItem(`SalePriceList${country}`, JSON.stringify(list));
  return list;
};
const getSalePriceList = function (country) {
  let sessionStorage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.sessionStorage;
  // first check if we have a list in sessionStorage
  const storedList = sessionStorage.getItem(`SalePriceList${country}`);
  if (storedList) {
    const list = JSON.parse(storedList);
    return list;
  }
  // If not stored in sessionStorage or expired, fetch new data
  const list = fetchPriceList(country);
  return list;
};

export { buildPriceModel, getCurrencyCode, getSalePriceList, priceDisplaySettings, priceFormat };
//# sourceMappingURL=index.js.map
